import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';

const ContentLoader: React.FC = React.memo(() => (
  <div className="blog-index-main">
    <div
      style={{
        alignItems: 'center',
        display: 'flex',
        justifyContent: 'center',
        height: '100vh',
        color: 'black',
        minHeight: '100vh',
      }}
    >
      <CircularProgress color="inherit" />
    </div>
  </div>
));

export default ContentLoader;
